(function () {
  const productContents = document.querySelectorAll(".main-product__content");
  const stickyCart = document.querySelector(".sticky-add-to-cart");

  productContents.forEach((container) => {
    const plusBtn = container.querySelector('button[name="plus"]');
    const minusBtn = container.querySelector('button[name="minus"]');
    const qtyInput = container.querySelector('input[name="quantity"]');
    const errorEl = container.querySelector(".quantity__error");
    
    let stickyPlusBtn = null;
    let stickyMinusBtn = null;
    let stickyQtyInput = null;
    let stickyErrorEl = null;

    if (stickyCart) {
      stickyPlusBtn = stickyCart.querySelector('button[name="plus"]');
      stickyMinusBtn = stickyCart.querySelector('button[name="minus"]');
      stickyQtyInput = stickyCart.querySelector('input[name="quantity"]');
      stickyErrorEl = stickyCart.querySelector(".quantity__error");
    }

    let currentQty = 1;

    const showOnlyError = (maxVal) => {
      const errorMsg = `Only ${maxVal} available`;
      if (errorEl) {
        errorEl.textContent = errorMsg;
        errorEl.style.display = "block";
      }
      if (stickyErrorEl) {
        stickyErrorEl.textContent = errorMsg;
        stickyErrorEl.style.display = "block";
      }
    };

    const hideOnlyError = () => {
      if (errorEl) {
        errorEl.style.display = "none";
      }
      if (stickyErrorEl) {
        stickyErrorEl.style.display = "none";
      }
    };

    const updateQuantityValues = (newVal) => {
      // Ensure we don't go below 1
      let valueToSet = Math.max(1, newVal);
      let showWarning = false;
      let maxVal = null;
      
      // Get the current max from input (it gets updated dynamically by variant selection)
      if (qtyInput) {
        const maxAttr = qtyInput.getAttribute("max");
        if (maxAttr !== null && maxAttr !== "") {
          maxVal = parseInt(maxAttr, 10);
          if (!isNaN(maxVal)) {
            if (newVal > maxVal) {
              showWarning = true;
            }
            valueToSet = Math.min(valueToSet, maxVal);
          }
        }
        qtyInput.value = valueToSet;
      }

      const hiddenQty = container.querySelector("#quantity");
      if (hiddenQty) {
        hiddenQty.value = valueToSet;
      }

      if (stickyCart) {
        const stickyInput = stickyCart.querySelector(".quantity input");
        if (stickyInput) {
          stickyInput.value = valueToSet;
        }
        const stickyHiddenQty = stickyCart.querySelector("#quantity");
        if (stickyHiddenQty) {
          stickyHiddenQty.value = valueToSet;
        }
      }

      currentQty = valueToSet;

      if (showWarning && maxVal !== null) {
        showOnlyError(maxVal);
      } else {
        hideOnlyError();
      }
    };

    if (qtyInput && container.querySelector("#quantity")) {
      currentQty = parseInt(container.querySelector("#quantity").value, 10) || 1;

      // Plus Button
      if (plusBtn) {
        plusBtn.addEventListener("click", function () {
          updateQuantityValues(currentQty + 1);
        });
      }

      // Minus Button
      if (minusBtn) {
        minusBtn.addEventListener("click", function () {
          updateQuantityValues(currentQty - 1);
        });
      }

      // Input Change
      qtyInput.addEventListener("change", function (e) {
        const parsed = parseInt(e.target.value, 10);
        updateQuantityValues(isNaN(parsed) ? 1 : parsed);
      });

      // Keypress filter
      qtyInput.addEventListener("keypress", function (e) {
        if ((e.which !== 8 && e.which !== 0 && e.which < 48) || e.which > 57) {
          e.preventDefault();
        }
      });

      // Sticky add to cart listeners
      if (stickyCart && stickyPlusBtn && stickyMinusBtn && stickyQtyInput) {
        stickyPlusBtn.addEventListener("click", function () {
          updateQuantityValues(currentQty + 1);
        });

        stickyMinusBtn.addEventListener("click", function () {
          updateQuantityValues(currentQty - 1);
        });

        stickyQtyInput.addEventListener("change", function (e) {
          const parsed = parseInt(e.target.value, 10);
          updateQuantityValues(isNaN(parsed) ? 1 : parsed);
        });

        stickyQtyInput.addEventListener("keypress", function (e) {
          if ((e.which !== 8 && e.which !== 0 && e.which < 48) || e.which > 57) {
            e.preventDefault();
          }
        });
      }

      // Variant Change Listener
      const formId = qtyInput.getAttribute("form");
      const form = formId ? document.getElementById(formId) : container.querySelector("form");
      if (form) {
        const idInput = form.querySelector('input[name="id"]');
        const inventoryScript = container.querySelector(".variant-inventory-json");

        if (idInput && inventoryScript) {
          try {
            const inventoryData = JSON.parse(inventoryScript.textContent);

            const handleVariantChange = () => {
              const selectedVariantId = idInput.value;
              const inventoryInfo = inventoryData[selectedVariantId];

              if (inventoryInfo) {
                const isTracked = inventoryInfo.inventory_management !== null && inventoryInfo.inventory_management !== "";
                const isDeny = inventoryInfo.inventory_policy === "deny";

                if (isTracked && isDeny) {
                  const maxQty = parseInt(inventoryInfo.inventory_quantity, 10);
                  qtyInput.setAttribute("max", maxQty);
                  if (stickyQtyInput) {
                    stickyQtyInput.setAttribute("max", maxQty);
                  }
                  
                  // If the current input quantity exceeds the max, lower it
                  const currentInputVal = parseInt(qtyInput.value, 10) || 1;
                  if (currentInputVal > maxQty) {
                    updateQuantityValues(maxQty);
                    showOnlyError(maxQty);
                  } else {
                    hideOnlyError();
                  }
                } else {
                  qtyInput.removeAttribute("max");
                  if (stickyQtyInput) {
                    stickyQtyInput.removeAttribute("max");
                  }
                  hideOnlyError();
                }
              }
            };

            idInput.addEventListener("change", handleVariantChange);
            // Run initially to sync with the pre-selected variant
            handleVariantChange();
          } catch (err) {
            console.error("Error parsing variant inventory JSON:", err);
          }
        }
      }
    }
  });
})();